module.exports = __webpack_public_path__ + "img/dummyprod10@2x.7d9e0c53.png";